import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getPurchases = (query,token) => {
    let qs = buildQuery(query);
    let url = `${baseUrl}/purchases${qs}`;
    return axios.get(url, {
        headers: {
            authorization: token
        }
    })
}
export const getallpurchaseOrders = (token,query) => {
    let qs = buildQuery(query);
    let url = `${baseUrl}/getallpurchaseOrders${qs}`;
    return axios.get(url, {
        headers: {
            authorization: token
        }
    })
}

export const createPurchase = (data, token) => axios.post(`${baseUrl}/purchase`, data, {
    headers: {
        authorization: token
    }
})

export const deletePurchase = (id, token) => axios.delete(`${baseUrl}/purchase/${id}`, {
    headers: {
        authorization: token
    }
})

export const updatePurchase = (id, data, token) => axios.patch(`${baseUrl}/purchase/${id}`, data, {
    headers: {
        authorization: token
    }
})

export const getPurchaseById = (id, token) => axios.get(`${baseUrl}/purchase/${id}`, {
    headers: {
        authorization: token
    }
})

// export const getProjectsByUserId = (id, query, token) => {
//     let qs = buildQuery(query);
//     let url = `${baseUrl}/projects/user/${id}${qs}`;
//     return axios.get(url, {
//         headers: {
//             authorization: token
//         }
//     })
// }
export const insertNewpurchaseOrder = (data, token) => axios.post(`${baseUrl}/insertNewpurchaseOrder`, data, {
    headers: {
        authorization: token
    }
})